import { useShipments } from '@/hooks/useShipments'
import { AppIcon } from '@/components/ui/app-icon'
import { StatusBadge } from '@/components/ui/status-badge'
import { LoadingSpinner } from '@/components/ui/loading-spinner'
import { SHIPMENT_STATUS } from '@/lib/constants'
import { formatDateTime } from '@/lib/utils'
import { useNavigate } from 'react-router-dom'

export function WorkerShipmentList() {
  const { data: shipments, isLoading } = useShipments()
  const navigate = useNavigate()

  if (isLoading) return <LoadingSpinner className="mt-20" />

  return (
    <div>

      {!shipments?.length ? (
        <div className="text-center text-gray-500 py-20">
          <p className="text-lg">Нет отгрузок</p>
        </div>
      ) : (
        <div className="bg-white rounded-lg shadow overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <tr>
                <th className="px-4 py-3">ID</th>
                <th className="px-4 py-3">Дата создания</th>
                <th className="px-4 py-3">Статус</th>
                <th className="px-4 py-3">Комментарий</th>
                <th className="px-4 py-3">Позиций</th>
                <th className="px-4 py-3">Экспорт</th>
                <th className="px-4 py-3" />
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              {shipments.map(s => {
                const meta = SHIPMENT_STATUS[s.status]
                return (
                  <tr key={s.id} className="hover:bg-gray-50" onClick={() => navigate(`/worker/shipments/${s.id}`)}>
                    <td className="px-4 py-3 font-mono text-xs">{s.id}</td>
                    <td className="px-4 py-3 text-gray-500">{formatDateTime(s.created_at)}</td>
                    <td className="px-4 py-3">
                      <StatusBadge color={meta.color} textColor={meta.textColor}>{meta.label}</StatusBadge>
                    </td>
                    <td className="px-4 py-3 text-gray-600 max-w-[12rem] truncate" title={s.comment || undefined}>
                      {s.comment?.trim() ? s.comment : <span className="text-gray-400">—</span>}
                    </td>
                    <td className="px-4 py-3 text-center">
                      {s.additions_count}
                      <span className="text-gray-400 text-xs"> / {s.items_count}</span>
                    </td>
                    <td className="px-4 py-3">
                      {s.exported ? <span className="text-green-600 text-xs font-medium inline-flex items-center gap-1"><AppIcon name="reports" className="h-3 w-3" /> Экспортирована</span> : <span className="text-gray-400 text-xs">Не экспортирована</span>}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
